import React, { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { EditorialGuidePage } from './EditorialGuidePage';
import { evaluateEditorialGuide } from '../utils/seoPolicy';
import { breadcrumbJsonLd, safeJsonLd } from '../utils/editorialHead';
import approvedPaths from '../generated/seo-approved-paths.json';
import { restorePrerenderFocus } from '../utils/prerenderFocus';

// Route element for a registered static editorial guide. Content, title, description, canonical and robots all come
// from the reviewed fixture plus the explicit manifest approval list: no database query, so nothing about the legacy
// editorial record can change what is indexed. First render already carries the final head (no loading state).
export function EditorialGuideRoute({ guide }) {
  const seo = evaluateEditorialGuide({ guide, approved: approvedPaths });
  // After React's first commit replaced the prerendered DOM, give focus back to the element the user had focused.
  useLayoutEffect(() => { restorePrerenderFocus(); }, []);
  return (
    <>
      <Helmet>
        <title>{guide.metaTitle}</title>
        <meta name="description" content={guide.metaDescription} />
        <meta name="robots" content={seo.robots} />
        <meta name="googlebot" content={seo.robots} />
        {seo.canonical && <link rel="canonical" href={seo.canonical} />}
        <meta property="og:title" content={guide.metaTitle} />
        <meta property="og:description" content={guide.metaDescription} />
        {seo.canonical && <meta property="og:url" content={seo.canonical} />}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="TechieDay" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{safeJsonLd(breadcrumbJsonLd(guide))}</script>
      </Helmet>
      <EditorialGuidePage guide={guide} />
    </>
  );
}
